export const ROUTES_PATH = {
    ONLINE_APPOINTMENT: '/consulta-online',
    FACE_BIOMETRICS_SCREEN: '/biometria',
    FORWARDING_APP: '/link',
    LOGIN: '/login',
    LOGIN_WITH_OTP: '/entrar/otp',
    LOGIN_OLD: '/login',
    LOGIN_AUTO: '/login-auto',
    UNIQUE_ACCESS: '/acesso-unico',
    LOGIN_SELECT_LABORATORY: '/login/selecionar-laboratorio',
    LOGIN_CIP_ERROR: '/login/erro-acesso-protocolo',
    LOGIN_ACTIVATION_REGISTRATION_EXAMS: '/login/ativacao-cip/cadastro-exames',
    SIGN_IN: '/entrar',
    SIGN_IN_WITH_LINK: '/entrar/via-link',
    SIGN_IN_SELF_SERVICE: '/entrar/autoatendimento',
    EXAMS_SELF_SERVICE: '/exames/autoatendimento',
    RECOVER_PASSWORD: '/recuperar-senha',
    RECOVER_PASSWORD_STEP: '/recuperar-senha/:stepId?',
    RECOVER_PASSWORD_ACTIVATE_ACCOUNT: '/recuperar-senha/ativar-conta',
    SIGN_UP_HOME_REDIRECT: '/cadastrar',
    SIGN_UP_PERSONAL_DATA: '/cadastrar/dados-pessoais',
    SIGN_UP_CREATE_PASSWORD: '/cadastrar/criar-senha',
    SIGN_UP_PHONE: '/cadastrar/telefone',
    SIGN_UP_VALIDATE_TOKEN: '/cadastrar/token',
    SIGN_UP_SELECT_CONTACT: '/cadastrar/selecionar-contato',
    SIGN_UP_REGISTRE_ACTIVATE_ACCOUNT: '/cadastrar/ativar-conta',
    SIGN_UP_MDM_CREATE_PASSWORD: '/cadastrar/criar-senha/mdm',
    SIGN_UP_MDM_SELECT_CONTACT: '/cadastrar/selecionar-contato/mdm',
    SIGN_UP_MDM_VALIDATE_TOKEN: '/cadastrar/token/mdm',
    SIGN_UP_REGISTER_ACTIVATION_CPF: '/cadastrar/ativacao-cip/cpf',
    SIGN_UP_NEW_CIP_BIOLOGICAL_SEX: '/cadastrar/ativacao-cip/novo/sexo-biologico',
    SIGN_UP_NEW_CIP_CREATE_PASSWORD: '/cadastrar/ativacao-cip/novo/criar-senha',
    SIGN_UP_NEW_CIP_PHONE: '/cadastrar/ativacao-cip/novo/telefone',
    SIGN_UP_NEW_CIP_VALIDATE_TOKEN: '/cadastrar/ativacao-cip/novo/token',
    SIGN_UP_MDM_CIP_CREATE_PASSWORD: '/cadastrar/ativacao-cip/mdm/criar-senha',
    SIGN_UP_MDM_CIP_SELECT_CONTACT: '/cadastrar/ativacao-cip/mdm/selecionar-contato',
    SIGN_UP_MDM_CIP_VALIDATE_TOKEN: '/cadastrar/ativacao-cip/mdm/token',
    SIGN_UP_REGISTER_EXAMS_ACTIVATE_CIP_ORPHAN: '/cadastrar/ativacao-cip/mdm/cadastro-exames',
    SIGN_UP_REGISTER_EXAMS_ACTIVATE_NEW_CIP_ORPHAN: '/cadastrar/ativacao-cip/novo/cadastro-exames',
    EXTERNAL_LOGIN: '/external-login',
    EXTERNAL_COMPANY: '/external/:company',
    LOGIN_CHECK_PARTNER: '/login/checkPartner',
    PARTNERS_TOKEN: '/entrar/parceiros/:token',
    REDIRECT_PAGE: '/redirecionamento',
    LOGOUT: '/sair',
    SESSION_EXPIRED: '/sessao-expirada',
    NEW_SESSION_EXPIRED: '/entrar?origin=sessao-expirada',
    REDIRECT_PAGE_NOT_FOUND: '/nao-encontrado',
    LANDING_PAGE: '/',
    UPDATE_CONTACTS: '/atualizar-contatos',
    HOME: '/plataforma/inicio',
}
